import React, { useState } from 'react';
import { connect } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { closeTestingDialog } from 'reducers/DialogsReducer';
import Dialog from 'components/Dialog';
import TimeTesting from './TimeTesting';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PermissionsTesting from './PermissionsTesting';
import TimeTesting2 from './TimeTesting2';
import PerformanceTesting from './PerformanceTesting';
import LegacyRMSExport from './LegacyRMSExport';
import ExampleTesting from './ExampleTesting';
import E911Testing from './E911Testing';
import PlacesTesting from './PlacesTesting';

const useStyles = makeStyles(() => ({
  content: {
    width: 1500,
    margin: '-20px -20px -16px',
    maxWidth: 'calc(100% + 40px)',
    height: 'calc(100vh - 180px)',
    boxSizing: 'border-box',
  },
}));

const TIME = 'TIME';
const TIME2 = 'TIME2';
const PERMISSIONS = 'PERMISSIONS';
const PERFORMANCE = 'PERFORMANCE';
const RMS_EXPORT = 'RMS_EXPORT';
const EXAPMLE = 'EXAPMLE';
const E911 = 'E911';
const PLACES = 'PLACES';

function TestingDialog(props) {
  const classes = useStyles();
  const [tab, setTab] = useState(PLACES);
  const close = () => {
    props.closeTestingDialog();
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const renderActions = () => {
    return (
      <>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  return (
    <Dialog toolbar onClose={close} title="Testing" actions={renderActions()}>
      <div className={classes.content}>
        <Tabs value={tab} onChange={handleTabChange} variant="scrollable">
          {/* <Tab label="Example" value={EXAPMLE} /> */}
          <Tab label="Time" value={TIME} />
          <Tab label="Time2" value={TIME2} />
          <Tab label="Permissions" value={PERMISSIONS} />
          <Tab label="Performance" value={PERFORMANCE} />
          <Tab label="RMS Export" value={RMS_EXPORT} />
          <Tab label="E911" value={E911} />
          <Tab label="RMS Export" value={RMS_EXPORT} />
          <Tab label="Places" value={PLACES} />
        </Tabs>
        {tab === EXAPMLE && <ExampleTesting />}
        {tab === TIME && <TimeTesting />}
        {tab === TIME2 && <TimeTesting2 />}
        {tab === PERMISSIONS && <PermissionsTesting />}
        {tab === PERFORMANCE && <PerformanceTesting />}
        {tab === RMS_EXPORT && <LegacyRMSExport />}
        {tab === E911 && <E911Testing />}
        {tab === RMS_EXPORT && <LegacyRMSExport />}
        {tab === PLACES && <PlacesTesting />}
      </div>
    </Dialog>
  );
}

export default connect(null, { closeTestingDialog })(TestingDialog);
